/* eslint-disable max-len */
export const validateEmail = (emailAddress: string): boolean => /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(emailAddress);
export const validateEmailSimple = (emailAddress: string): boolean => /^\S+@\S+\.\S+$/.test(emailAddress);
